import React, { useContext } from 'react';
import {
  Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Breadcrumb,
  Title,
} from './components';

import colorContext from '../../Context/colorContext';

export default function ServiceEvaluationMethodology():JSX.Element {
  const { colors } = useContext(colorContext);
  const useStyles = makeStyles(() => ({
    main: {
      width: '100%',
      minHeight: 399,
      display: 'flex',
      backgroundColor: colors.colorBackground,
      flexDirection: 'column',
      alignItems: 'center',
      color: colors.textBody,
      lineHeight: '24px',
    },
    box: {
      width: '100%',
      maxWidth: '1440px',
      marginBottom: '40px',
    },
  }));
  const classes = useStyles();

  return (
    <Box className={classes.main}>
      <Breadcrumb slug="Metodologia de Avaliação de Serviços" />
      <Title />
      <Box padding="49px 10px">
        <Box className={classes.box}>
          <h2>METODOLOGIA DE AVALIAÇÃO DE SATISFAÇÃO DOS USUÁRIOS DO PORTAL DE SERVIÇOS DO ESTADO DO AMAPÁ</h2>
          <p>
            A metodologia utilizada para avaliar a satisfação dos usuários no portal de serviço do
            estado do Amapá (AP Digital) é baseada no NET PROMOTER SCORE (NPS)
            utilizando coletas qualitativas e quantitativas, as ferramentas de coleta e análise de
            dados e os resultados obtidos, garantindo uma abordagem robusta e confiável para a
            gestão da qualidade dos serviços.
          </p>
          <p>
            O sistema utiliza um sistema de classificação por estrelas, no qual os usuários
            atribuem uma nota de 1 a 5 estrelas, representando o grau de satisfação com o
            serviço utilizado. Essas métricas fornecem um indicador numérico direto, permitindo a
            construção de indicadores de satisfação ao longo do tempo.
          </p>
          <p>
            <strong>Escala:</strong>
            <br />
            ★☆☆☆☆ (1) – Insatisfeito
            <br />
            ★★☆☆☆ (2) – Pouco Insatisfeito
            <br />
            ★★★☆☆ (3) – Pouco Satisfeito
            <br />
            ★★★★☆ (4) – Satisfeito
            <br />
            ★★★★★ (5) – Excelente
          </p>
          <h3>Validação da satisfação dos usuários</h3>
          <p>
            O cálculo para verificar a experiência do usuário é baseado na metodologia do Net
            Promoter Score, mas com alterações para adaptações dividindo em 3 tipos de
            respostas referente a satisfações agregando 5 estrelas e realizar o cálculo para
            verificar a porcentagem da experiência do usuário.
          </p>
          <p>
            <strong>Respostas Negativas</strong>
            {' '}
            = 1 a 2 estrelas
            <br />
            <strong>Respostas Neutras</strong>
            {' '}
            = 3 a 4 estrelas
            <br />
            <strong>Respostas Positiva</strong>
            {' '}
            = 5 estrelas
          </p>
          <p>
            <strong>Calculo da experiência</strong>
            {' '}
            = ((Respostas Positivas/Total de Respostas) *100) -
            ((Respostas negativas/ Total de Respostas) *100)
          </p>
          <p>
            Após realizar o cálculo teremos a porcentagem da experiência, os serviços são
            classificados em 4 zonas, que indicam o nível de satisfação dos usuários:
          </p>
          <ul>
            <li>
              <strong>Zona Crítica</strong>
              {' '}
              (–100 a -1): Muitos clientes relatam experiências negativas com o serviço.
            </li>
            <li>
              <strong>Zona de Aperfeiçoamento</strong>
              {' '}
              (0 a 49): Indica pontos que precisam ser melhorados.
            </li>
            <li>
              <strong>Zona de Qualidade</strong>
              {' '}
              (50 a 74): Requer poucos ajustes para aprimorar a experiência do usuário.
            </li>
            <li>
              <strong>Zona de Excelência</strong>
              {' '}
              (75 a 100): Representa uma experiência altamente positiva, com grande número de promotores e quase nenhum detrator
            </li>
          </ul>
          <div>
            <h3>Exemplo</h3>
            <p>
              Total de pessoas (TP) = 100
              <br />
              Número de Respostas Negativas (RN) = 5
              <br />
              Número de Respostas Neutras (N) = 15
              <br />
              Número de Respostas Positivas (RP) = 80
            </p>

            <p>
              <strong>Calculo da experiência do usuário:</strong>
              <br />
              (80/100*100) - (5/100*100) = 80 – 5 = 75 %
            </p>

            <p>
              O exemplo mostra que está na zona de excelência pontuando 75%, mostrando que o
              serviço está muito eficaz.
            </p>
          </div>
        </Box>
      </Box>
    </Box>
  );
}
